<int-labeled-field-box
  [isFocus]="focused"
  [isError]="isError"
  [isActive]="isFocused || isFill"
  [direction]="dir$ | async"
  [label]="currentLabel"
  [showLabelTip]="showLabelTip"
  [verticalAlign]="verticalAlign"
>
  <ng-container ngProjectAs="center-position">
    <ng-container *ngIf="{currentValue: (value$ | async) || ''} as stream$">
      <textarea
        class="i-textarea"
        int-default-input-field
        [class.f-error]="isError"
        aria-label="default"
        [readonly]="readonly"
        [disabled]="disabled"
        (onFocus)="onFocus()"
        (onInput)="onInput($event)"
        (onBlur)="onBlur()"
        [value]="stream$.currentValue"
        [style.height]="fieldHeight"
      ></textarea>
    </ng-container>
  </ng-container>
  <ng-container ngProjectAs="left-position">
    <ng-content select="left-position"></ng-content>
  </ng-container>
  <ng-container ngProjectAs="right-position">
    <ng-content select="right-position"></ng-content>
  </ng-container>
</int-labeled-field-box>

